import React from 'react';
import { CurrencyType } from '../types';
import { getAllCurrencies, getCurrencyDisplayText } from '../utils/shared';

interface CurrencyDropdownProps {
  value: CurrencyType;
  onChange: (currency: CurrencyType) => void;
  label?: string;
  id?: string;
  className?: string;
  disabled?: boolean;
}

const CurrencyDropdown: React.FC<CurrencyDropdownProps> = ({
  value,
  onChange,
  label,
  id = 'currency-select',
  className = 'currency-select',
  disabled = false
}) => {
  const allCurrencies = getAllCurrencies();

  return (
    <div className="currency-group">
      {label && <label htmlFor={id}>{label}</label>}
      <select 
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value as CurrencyType)}
        className={className}
        disabled={disabled}
      >
        {allCurrencies.map(currency => (
          <option key={currency} value={currency}>
            {getCurrencyDisplayText(currency)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencyDropdown; 